import type { ElementType, ReactNode } from "react";
import { cn } from "@/lib/utils";

interface JobDetailItemProps {
  label: string;
  value?: ReactNode;
  icon?: ElementType;
  /** Elemento à esquerda customizado (ex.: avatar), substitui o ícone. */
  leading?: ReactNode;
  emphasis?: "mono" | "primary";
  title?: string;
}

/**
 * Item atômico da grade de dados: marcador à esquerda, rótulo e valor.
 * Reutilizado por todos os campos para garantir consistência visual.
 */
export function JobDetailItem({
  label,
  value,
  icon: Icon,
  leading,
  emphasis,
  title,
}: JobDetailItemProps) {
  return (
    <div className="flex items-start gap-3">
      <div className="mt-0.5 shrink-0 text-muted-foreground">
        {leading ?? (Icon ? <Icon className="h-4 w-4" /> : null)}
      </div>
      <div className="min-w-0">
        <p className="mb-0.5 text-[10px] font-bold uppercase tracking-wider text-muted-foreground">
          {label}
        </p>
        <p
          className={cn(
            "truncate text-sm font-medium text-foreground",
            emphasis === "mono" && "font-mono text-primary",
            emphasis === "primary" && "text-primary",
          )}
          title={title}
        >
          {value ?? "-"}
        </p>
      </div>
    </div>
  );
}
